import { StringUtils, engineComponent } from "neo-common";
import { ComponentTypes } from "../../ComponentTypes";
import { ContainerElement } from "./ContainerElement";
import { ParticleElement, ParticleElementAttributes } from "./ParticleElement";

@engineComponent(ComponentTypes.DisplayObject)
// TODO add comments
export class ParticleGroupElement extends ContainerElement {
    private _emitOnce: boolean;
    private _startType: string;

    constructor() {
        super();

        this._emitOnce = false;
        this._startType = "";
    }

    create(node: Element): void {
        super.create(node);

        this.visible = false;

        this.controlParticles(node);
    }

    /**
     *
     * @param node
     */
    private controlParticles(node: Element): void {
        if (node.hasAttribute(ParticleElementAttributes.EMIT_ONCE)) {
            this._emitOnce = StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.EMIT_ONCE));
        }

        if (node.hasAttribute(ParticleElementAttributes.START_TYPE)) {
            this._startType = node.getAttribute(ParticleElementAttributes.START_TYPE);
        }

        if (
            node.hasAttribute(ParticleElementAttributes.START) &&
            StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.START))
        ) {
            this.start(this._emitOnce);
        }

        if (
            node.hasAttribute(ParticleElementAttributes.STOPPING) &&
            StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.STOPPING))
        ) {
            this.stopping();
        }

        if (
            node.hasAttribute(ParticleElementAttributes.STOP) &&
            StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.STOP))
        ) {
            this.stop();
        }
    }

    start(emitOnce: boolean = false): void {
        this._emitOnce = emitOnce;
        this.visible = true;
        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof ParticleElement) {
                    this.childs[key].start(this._emitOnce, this._startType);
                }
            }
        }
    }

    stopping(): void {
        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof ParticleElement) {
                    this.childs[key].stopping();
                }
            }
        }
    }

    stop(): void {
        this.visible = false;
        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof ParticleElement) {
                    this.childs[key].stop();
                }
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Graphics/ParticleGroupElement.ts
 **/